export const fr = {
	general: {
		'world': 'Bonjour le monde!',
		'Y': 'Oui',
		'N': 'Non',
	},

	gdpr: {
		title: "Avis de confidentialité",
		client: "NESTLE BELGILUX SA",
		adress: "Rue de Birmingham 221, 1070 BRUXELLES B",
	},

	footer: {
		genterms: "Conditions générales",
	},

	navigation: {
		previous: "Précédent",
		next: "Suivant",
		skipSurvey: "Demander le cashback",
		doSurvey: "Répondre à l'enquête",
	},

	auth: {
		form: {
			login: "Login",
			username:"Nom d'utilisateur",
			usernamePlaceholder: "Indiquez votre nom d'utilisateur",
			password: "Mot de passe",
		}
	},

	breadcrumbSteps: {
		registration: "Enregistrez-vous",
		store: "Faites vos achats",
		form: "Remplissez le formulaire",
		survey: "Répondez à un questionnaire optionnel",
		cashback: "Recevez votre remboursement"
	},

	product: {
		subtitle : "Assurer le maintien de notre système immunitaire.",
		subsubtitle : "La protection que nous méritons tous."
	},

	header: {
		macaron : "1 + 1 remboursé"
	},

	pageTitles: {
		maxReached: "Maximum de participations atteint",
		wrongCode: "Mauvais code",
		registration: "Inscrivez-vous et obtenez votre cashback&nbsp;!",
		alreadySend: "Participation déjà envoyée",
		confirmation: "Confirmation",
		beforeStart: "Cette action n'est pas encore disponible",
		actionEnded: "Cette action est terminée",
	},

	sectionTitles: {
		inscription: "Inscrivez-vous ici",
	},

	pageLitteracy: {
		maxReached : "Cette action est terminée car elle a atteint son maximum de participations.",
		wrongCode: "La clé fournie est erronée. Vous devez utiliser le lien que vous a envoyé Purina. Mais peut-être souhaitez-vous vous inscrire à l'action ?",
		signup: "M'inscrire !",
		alreadySend: "Vous avez déjà envoyé votre participation.",
		registration : {
			byRegistering: "En m'inscrivant à cette action, j'accepte ",
			privacyNotice: "la politique en matière de vie privée",
			claimMail : "S'inscrire par e-mail",
			claimWhatsapp: "S'inscrire par Whatsapp",
			claimSms: "S'inscrire par SMS",
			or: "Ou",
			whatsappTitle: "Cliquez sur le bouton Whatsapp",
			whatsappInfo: "Une fenêtre s'ouvrira, vous serez ensuite invité à envoyer le mot PURINAFR depuis votre Whatsapp.",
		},
		confirmInscription: {
			thanks: "Merci pour votre inscription !",
			smsLine1 :"Nous venons de vous envoyer un SMS avec tous les détails.",
			smsLine2: "Aller voir !",
			smsLine3: "Attention : Cette action est limitée à 8000 participations. Ne tardez donc pas à participer.",
			whatsappLine1: "Vérifiez votre téléphone",
			whatsappLine2: "Toutes les informations ont été envoyées par Whatsapp",
			whatsappLine3: "Attention : Cette action est limitée à 8000 participations. Ne tardez donc pas à participer.",
			mailLine1: "Nous venons de vous envoyer un e-mail avec tous les détails.",
			mailLine2: "Découvrez cet e-mail !",
			mailLine3: "Attention : Cette action est limitée à 8000 participations. Ne tardez donc pas à participer.",
		},
		landing: {
			mainTitle: "Demandez votre cashback maintenant !",
			aboutYou: "Dites-nous en plus à votre propos",
			popTitle : "Preuve d'achat",
			agree: "J'accepte les",
			termsAndConditions: "conditions générales",
			moreInfo: `Oui, j'aimerais recevoir les dernières nouvelles et offres de Purina ONE et des autres marques du groupe Nestlé. J’accepte la <a href="https://www.nestle.be/fr/info/yourdata">politique de Nestlé</a> quant à l’utilisation de mes données. Je comprends que je peux retirer mon consentement à tout moment.`,
			moreInfoHelper: "Nous vous enverrons en moyenne un e-mail tous les deux mois.",
			claimCashback: "Demander mon cashback",
		},
		choiceSurvey: {
			title: "",
			fillSurveyIncite: "Répondez encore à une enquête et obtenez un e-coupon de 2€ valable sur votre prochain achat",
		},
		survey: {
			title: "",
			aboutCat: "À propos de votre chat",
		},
		confirmation: {
			title: "Confirmation",
			textes: {
				p1: "Nous vous remercions pour votre participation à l'action Purina ONE.",
				p2: "Vous recevrez votre remboursement dans les 24 jours pour autant que vous ayez rempli les conditions générales.",
				p3: "Bien à vous,",
				p4: "L'équipe Purina ONE"
			},
		},
		beforeStart: {
			text: "Vous pourrez y accéder à partir du",
		},
		actionEnded: {
			text: "N'hésitez pas à visiter régulièrement notre site pour vous tenir informé des actions futures.",
		},
	},





	inputLabel: {
		defaultListHelper: "Choisissez une proposition dans la liste",
		mandatoryFields: "Champs obligatoires",


		title : {
			label : "Titre",
			placeholder : "Comment pouvons-nous vous appeler ?",
			helper : "",
		},
		firstname: {
			label: "Indiquez votre prénom",
			placeholder : "Prénom",
			helper: "",
		},
		lastname: {
			label: "Indiquez votre nom",
			placeholder : "Nom",
			helper: "",
		},
		email : {
			label: "Indiquez votre e-mail ici",
			placeholder: "dupont{'@'}exemple.be",
			helper: "Votre e-mail doit comporter un {'@'}"
		},
		phone : {
			label: "Indiquez votre numéro de mobile",
			placeholder: "+32123456789",
			helper: "Il doit être écrit avec le code international"
		},
		iban : {
			label: "Indiquez votre numéro IBAN",
			placeholder: "",
			helper: ""
		},
		popitem : {
			label: "Sur les deux produits Purina ONE Chats achetés, indiquez le produit le moins cher",
			placeholder: "Choisissez un produit dans la liste",
			helper: "",
		},
		empty : {
			label: "",
			placeholder: "",
			helper: ""
		},

		// https://vue-i18n.intlify.dev/guide/essentials/syntax.html#literal-interpolation
/*
		typePassword : "Indiquez votre mot de passe",
		helpPassword : "Votre mot de passe doit contenir X, Y et Z",
		typeUniqueCode : "Indiquez ici le code visible sur le ticket de caisse",
		*/


		upload: {
			state: "statut",
			uploadYourFile: "Envoyer vos fichiers",
			clickOrDrop: "Cliquez ou déposer votre ticket ici.",
			remove: "Retirer",
			waiting: "En attente de l'envoi…",
			uploaded: "Envoyé !",
			error: "Echoué",
			uploadsDone: "Upload réussi",
			onlyImages: "Seulement des images ou des pdf sont acceptés.",
			maxSize: "Taille maximum de 20 Mo.",
			uploadFile: "Télécharger le fichier",
			generalError: "Erreur, veuillez ressayer plus tard",
			emptyFile: "Vous devez envoyer un fichier",
		}
	},

	temporary: {

		surveyQ417 : {
			label : "Date de naissance de votre chat",
			placeholder: "",
			helper: ""
		},
		surveyQ418: {
			label: "Donnez-vous habituellement dans la même journée de la nourriture sèche et humide à votre chat ?",
			placeholder: "Choisissez une réponse",
			helper: "",
		},
		surveyQ419: {
			label: "Si non, est-ce principalement de la nourriture sèche ou humide ?",
			placeholder: "Choisissez une réponse",
			helper: "",
		},
		surveyQ420: {
			label: "Donnez-vous principalement les croquettes Purina ONE à votre Chat ? ",
			placeholder: "Choisissez une réponse",
			helper: "",
		},
		surveyQ421: {
			label: "Si non, quelle(s) marque(s) donnez-vous principalement ?",
			placeholder: "",
			helper: "",
		},
		surveyQ422: {
			label: "Donnez-vous principalement les sachets fraicheurs Purina ONE à votre Chat ?",
			placeholder: "Choisissez une réponse",
			helper: ""
		},
		surveyQ423: {
			label: "Si non, quelle(s) marque(s) donnez-vous principalement ?",
			placeholder: "",
			helper: ""
		},
		surveyQ424 : {
			label : "Nom de votre chat",
			placeholder: "",
			helper: ""
		},
	},

	validations: {
		dateInvalid: "Date invalide.",
		dateBefore: "Choisi un date avant aujourd’hui"
	}
}
